var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudGrayLg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 220,
  height: 160,
  fill: "none",
  viewBox: "0 0 220 160",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 80,
  r: 80,
  fill: "var(--utility-gray-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 20,
  r: 8,
  fill: "var(--utility-gray-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 126,
  r: 6,
  fill: "var(--utility-gray-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 138,
  r: 10,
  fill: "var(--utility-gray-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 210,
  cy: 46,
  r: 10,
  fill: "var(--utility-gray-100, black)"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 11,
  r: 7,
  fill: "var(--utility-gray-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_1182_2774)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-50, black)",
  fillRule: "evenodd",
  d: "M113.486 16c-16.737 0-31.541 8.27-40.55 20.947a40 40 0 0 0-9.165-1.061C41.806 35.886 24 53.692 24 75.657s17.806 39.772 39.771 39.772H163.2c19.22 0 34.8-15.58 34.8-34.8s-15.58-34.8-34.8-34.8q-2.049 0-4.036.231C151.546 28.378 133.961 16 113.486 16",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.771,
  cy: 75.657,
  r: 39.771,
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113.486,
  cy: 65.714,
  r: 49.714,
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163.2,
  cy: 80.629,
  r: 34.8,
  fill: "url(#c)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b_1182_2774)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-400, black)",
  d: "M82 112c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m120.5 122.5-4.083-4.083m2.916-7c0 5.476-4.44 9.916-9.916 9.916-5.477 0-9.917-4.44-9.917-9.916 0-5.477 4.44-9.917 9.917-9.917s9.916 4.44 9.916 9.917"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 33.233,
  x2: 103.543,
  y1: 49.38,
  y2: 115.429,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 75.312,
  x2: 163.2,
  y1: 32.867,
  y2: 115.428,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 136.479,
  x2: 198,
  y1: 57.636,
  y2: 115.429,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudGrayLg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloudGrayLg.76988cb7ffe451ef908bf0381e3d926d.svg";